import { Record, type RecordOf } from 'immutable';

import type { Address } from 'app-components/flux/addresses/addressTypes';
import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';
import { resourceStoreTypes } from '../core';

export const CUSTOMERS_REDUCER_KEY = 'customersStore';
export type CustomersStore = QcsSyncResourceStore<CustomerProps>;
export const mkCustomersStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<CustomerProps>();

export type PaymentInfo = {
  id?: string;
  platform?: string;
  username?: string;
  customerId?: string;
  isDeleted?: boolean;
  createdAt?: string;
};

export type CustomerProps = {
  id?: string;
  clientId?: string;
  createdAt?: string;
  firstName?: string;
  lastName?: string;
  businessName?: string;
  phoneNumber?: string;
  email?: string;
  privateNotes?: string;
  isDeleted?: boolean;
  isArchived?: boolean;
  address?: Address;
  paymentInfoList?: PaymentInfo[];
};

export type Customer = RecordOf<CustomerProps>;

export const mkCustomer = Record<CustomerProps>({
  id: undefined,
  clientId: undefined,
  createdAt: undefined,
  firstName: undefined,
  lastName: undefined,
  businessName: undefined,
  phoneNumber: undefined,
  email: undefined,
  privateNotes: undefined,
  isDeleted: undefined,
  isArchived: undefined,
  address: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [CUSTOMERS_REDUCER_KEY]: QcsSyncResourceStore<CustomerProps>;
  }
}
